import { IOption } from "./Form";
import { AddressInfo } from "./User";

export type Mutable<T> = { -readonly [P in keyof T]: T[P] };

export interface IRateTrend {
  origin: AddressInfo;
  destination: AddressInfo;
  equipment_type: IOption;
}

export interface IRateTrendForm {
  offset?: number;
  origin_city: string;
  origin_state: string;
  destination_city: string;
  destination_state: string;
  trailerTypes: string;
}

export interface IRateTrendResponse {
  id: string;
  origin_location: string;
  destination_location: string;
  distance: number;
  length: number;
  amount: number;
  weight: number;
  trailerType: string;
  created: string;
}

export interface IChartData {
  name: string;
  [trailerType: string]: number | string;
}

export enum LaneTrendType {
  METRIC = "metric",
  RATE_PER_MILE = "rate_per_mile",
  FUEL_COSTS = "fuel_costs",
  AVG_LINE = "avg_line"
}
